<script setup lang="ts">
import { useRoute, type RouteLocationNormalized } from 'vue-router';
import { useRouterTab } from './useRouterTab';

const route = useRoute();
const { cachedViews, getRefreshToken } = useRouterTab();

const getComponentKey = (r: RouteLocationNormalized) => {
  const tabKey = r.meta?.key as string;
  const base = tabKey && tabKey !== 'path' ? tabKey : r.fullPath;
  return base + '_' + getRefreshToken(r.fullPath);
};
</script>

<template>
  <div
    class="router-tab__container flex-grow-1 overflow-auto h-100 position-relative"
  >
    <router-view v-slot="{ Component }">
      <keep-alive :include="cachedViews">
        <component :is="Component" :key="getComponentKey(route)" />
      </keep-alive>
    </router-view>
    <ItpIframeKeepAliveHost />
  </div>
</template>
